<template>
  <div>
    <XDateType
      v-if="showDateType"
      :label="labelIcon('fa/regular/gift-card')"
      icon="fa/regular/gift-card"
      :date="reaction.relativeDate" />

    <XCard class="py-6 px-4">
      <div
        v-if="reaction.data.reward.ref"
        class="py-2 px-3 text-center">
        <div class="font-semibold text-lg mb-2">
          {{ $t('event.timeline.scratchAndWin.reaction.won.title') }}
        </div>

        <img
          v-if="imageUrl"
          :src="imageUrl"
          class="block w-auto mx-auto"
          style="max-height: 300px;">

        <i18n
          path="event.timeline.scratchAndWin.reaction.won.reward"
          tag="div"
          class="mt-2">
          <span
            place="reward"
            class="font-semibold">{{ reaction.data.reward.name }}</span>
          <span
            place="code"
            class="font-semibold">{{ reaction.data.code }}</span>
        </i18n>
      </div>

      <div
        v-else
        class="py-2 px-3 text-center">
        <div class="font-semibold text-lg mb-2">
          {{ $t('event.timeline.scratchAndWin.reaction.lost.title') }}
        </div>

        <img
          v-if="imageUrl"
          :src="imageUrl"
          class="block w-auto mx-auto"
          style="max-height: 300px;">

        <i18n
          path="event.timeline.scratchAndWin.reaction.lost.noReward"
          tag="div"
          class="mt-2">
          <span
            place="code"
            class="font-semibold">{{ reaction.data.code }}</span>
        </i18n>

        <div>
          {{ $t('event.timeline.scratchAndWin.reaction.lost.tryAgain') }}
        </div>
      </div>
    </XCard>
  </div>
</template>

<script>
import ReactionMixin from './ReactionMixin'

export default {
  mixins: [
    ReactionMixin
  ],

  data () {
    return {
      imageUrl: this.reaction.data.reward.image_url
    }
  }
}
</script>
